import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { withRouter } from "react-router-dom";
import { Form, Button, Card, Steps, Checkbox } from "antd";
import { LeftCircleTwoTone } from "@ant-design/icons";
import AndtDPasswordBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/PasswordBoxWrapper";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import Timer from "./Timer";
import { usernameValidator, strongPasswordValidator } from "../../validators";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import AuthDataProvider from "../../AuthDataProvider";
import { URLS, validator_messages, STEPS } from "../../constants";
import { NOTIFICATIONS } from "../../../LandingPage/constants";
import { ErrorLogger } from "../../../App/Utils/ErrorHandler";

const { Step } = Steps;

const gridStyle = {
  width: "100%",
};

class ResetUsername extends Component {
  formRef = React.createRef();
  DataProvider = new AuthDataProvider();
  currentStep = this.props.history.location.state.step;

  state = {
    currentStep: this.currentStep == undefined ? 0 : this.currentStep,
    change_username: true,
    username_available: false,
    isLoading: false,
    disable_new_username: false,
    username: localStorage.getItem(localStorageVariableName.userName),
    timerVisible: false,
  };

  componentDidMount() {
    this.formRef.current.setFieldsValue({
      old_username: this.state.username,
    });

    if (this.currentStep !== undefined) {
      this.forgetPassword();
    }
  }

  onFinish = (values) => {
    try {
      Object.keys(values).forEach((each) => {
        values[each] = window.btoa(values[each].trim())
      });

      this.setState({ isLoading: true });
      this.DataProvider.post_api_call(`${URLS.RESET_PASSWORD}`, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              Object.keys(res).map((success) => {
                openNotification(
                  openNotificationType.success,
                  success,
                  res[success]
                );
              });

              localStorage.clear();
              this.formRef.current.resetFields();
              this.props.history.push(URLS.LOGIN_URL);
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  checkUsername = () => {
    try {
      let values = this.formRef.current.getFieldsValue();
      let username = values["new_username"];
      this.setState({ isLoading: true });
      this.DataProvider.get_api_call(
        `${URLS.CHECK_USERNAME}?username=` + username
      )
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              if (res.data === "Username Available") {
                this.setState({ currentStep: this.state.currentStep + 1 });
              } else {
                openNotification(
                  openNotificationType.error,
                  notificationTitle.form,
                  validator_messages.USERNAME_EXISTS
                );
              }
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  forgetPassword = () => {
    try {
      let values = {
        screen: "First Login",
        username: this.state.username,
      };

      if (this.currentStep !== undefined) {
        values.screen = "OTP Verification";
      }

      Object.keys(values).forEach((each) => {
        values[each] = window.btoa(values[each].trim());
      });

      this.setState({ isLoading: true });
      this.DataProvider.post_api_call(`${URLS.FORGET_PASSWORD}`, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              openNotification(
                openNotificationType.success,
                Object.keys(res)[0],
                res.Success
              );
              localStorage.setItem("otp-duration", res.duration);

              if (this.currentStep !== undefined) {
                this.setState({ timerVisible: true });
              }else{
                this.setState({ currentStep: this.state.currentStep + 1 });
              }
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  NextPrevSteps = async (currentStep) => {
    try {
      switch (currentStep) {
        case 0:
          let values = this.formRef.current.getFieldsValue();
          if (values["old_username"] === values["new_username"]) {
            openNotification(
              openNotificationType.error,
              notificationTitle.form,
              validator_messages.SAME_USERNAME
            );
          } else {
            let isValid = await this.formRef.current
              .validateFields(["new_username"])
              .catch(this.onFinishFailed);

            if (isValid && values["new_username"].length > 7) {
              this.checkUsername();
            } else {
              currentStep = isValid ? this.state.currentStep + 1 : 0;
            }
          }
          break;
        case 1:
          let value = this.formRef.current.getFieldsValue();
          if (value["npassword"] !== value["cpassword"]) {
            openNotification(
              openNotificationType.error,
              notificationTitle.form,
              validator_messages.CONFIRM_PASSWORD
            );
          } else {
            let Valid = await this.formRef.current
              .validateFields(["npassword", "cpassword"])
              .catch(this.onFinishFailed);

            this.forgetPassword();
          }
          break;
        case 2:
          let valid = await this.formRef.current
            .validateFields(["otp"])
            .catch(this.onFinishFailed);

          currentStep = 2;
          if (valid === true) {
            this.formRef.current.submit();
          }
          break;
        case STEPS.prev:
          currentStep = this.state.currentStep - 1;
          break;
        default:
          break;
      }
      this.setState({ currentStep });
    } catch (error) {
      ErrorLogger(toString());
      console.error(error);
    }
  };

  goBack = () => {
    try {
      if (this.state.currentStep === 0) {
        this.props.history.goBack();
      } else {
        this.NextPrevSteps(STEPS.prev);
      }
    } catch (error) {
      console.error(error);
    }
  };

  setCardTitle = () => {
    try {
      if (this.state.currentStep === 0) {
        return STEPS.reset_username;
      } else if (this.state.currentStep === 1) {
        return STEPS.reset_password;
      } else {
        return STEPS.verification;
      }
    } catch (error) {
      console.error(error);
    }
  };

  validateOTP = (values) => {
    try {
      Object.keys(values).forEach((each) => {
        values[each] = window.btoa(values[each].trim());
      });

      this.setState({ isLoading: true });
      this.DataProvider.post_api_call(`${URLS.LOGIN}`, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              if (process.env.NODE_ENV === "development") {
                localStorage.setItem(
                  localStorageVariableName.authToken,
                  JSON.stringify("Token " + res["Your Token"])
                );
              }
              localStorage.setItem("pk", res["pk"]);
              localStorage.setItem("is_staff", res.is_staff);
              localStorage.setItem(localStorageVariableName.isLoggedIn, true);

              this.props.history.push({ pathname: URLS.LOGIN_URL });
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  render() {
    const {
      currentStep,
      change_username,
      disable_new_username,
      isLoading,
      timerVisible,
    } = this.state;

    if (this.currentStep) {
      return (
        <>
          <Modal show={isLoading} centered>
            <Modal.Body>
              <FormLoader loading="true" />
            </Modal.Body>
          </Modal>

          <Form
            onFinish={this.validateOTP}
            layout="vertical"
            ref={this.formRef}
            className="container_bg text-center"
            autoComplete="off"
          >
            <Card
              title={this.setCardTitle()}
              className="main_card p-1"
            >
              <Card.Grid style={gridStyle} hoverable={false}>
                <div className="col-lg-12 col-md-12 text-right">
                  <AndtDTextBoxWrapper
                    decorator="old_username"
                    id="old_username"
                    required={false}
                    disabled={true}
                    label="Username"
                    message="Enter Username"
                    placeholder="Enter Username"
                    casetype="uppercase"
                    validators=""
                    formRef={this.formRef}
                  />

                  {timerVisible && (
                    <Timer
                      formRef={this.formRef}
                      currentStep={this.currentStep}
                    />
                  )}
                </div>

                <div className="col-lg-12 col-md-12 text-center">
                  <Button htmlType="submit" type="primary">
                    Submit
                  </Button>
                </div>
              </Card.Grid>
            </Card>
          </Form>
        </>
      );
    }

    return (
      <>
        <Modal show={isLoading} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>

        <Form
          onFinish={this.onFinish}
          layout="vertical"
          ref={this.formRef}
          className="container_bg text-center"
          autoComplete="off"
        >
          <Card
            title={this.setCardTitle()}
            className="main_card p-1"
            extra={
              <Button type="link">
                <LeftCircleTwoTone
                  onClick={this.goBack}
                  className="back-icon"
                />
              </Button>
            }
          >
            <Card.Grid hoverable={false} style={gridStyle}>
              <div>
                <Steps
                  size={"small"}
                  current={currentStep}
                  // onChange={this.NextPrevSteps}
                >
                  <Step title={STEPS.reset_username} />
                  <Step title={STEPS.reset_password} />
                  <Step title={STEPS.verification} />
                </Steps>
              </div>
            </Card.Grid>

            <div hidden={currentStep === 0 ? false : true}>
              <Card.Grid style={gridStyle} hoverable={false}>
                <div className="col-lg-12 col-md-12">
                  <AndtDTextBoxWrapper
                    decorator="old_username"
                    id="old_username"
                    required="true"
                    label="Old Username"
                    disabled={true}
                    message="Enter Old Username"
                    placeholder="Enter Old Username"
                    casetype="uppercase"
                    validators=""
                    formRef={this.formRef}
                  />
                </div>

                <div
                  className="col-lg-12 col-md-12"
                  style={{ textAlign: "left" }}
                >
                  <AndtDTextBoxWrapper
                    decorator="new_username"
                    id="new_username"
                    required={change_username}
                    disabled={disable_new_username}
                    label="New Username"
                    message="Enter New Username"
                    placeholder="Enter New Username"
                    casetype="uppercase"
                    validators={[{ validator: usernameValidator }]}
                    formRef={this.formRef}
                  />
                </div>

                <div className="col-lg-6 col-md-12">
                  <Checkbox
                    onChange={() => {
                      this.formRef.current.setFieldsValue({
                        new_username: "",
                      });
                      this.setState({
                        change_username: this.state.change_username
                          ? false
                          : true,
                        disable_new_username: this.state.disable_new_username
                          ? false
                          : true,
                      });
                    }}
                  >
                    I Don't Want To Change Username
                  </Checkbox>
                </div>

                <div
                  className="col-lg-12 col-md-12 text-center"
                  style={{ paddingTop: "20px" }}
                >
                  <Button
                    type="primary"
                    onClick={() => this.NextPrevSteps(this.state.currentStep)}
                  >
                    Next
                  </Button>
                </div>
              </Card.Grid>
            </div>

            <div hidden={currentStep === 1 ? false : true}>
              <Card.Grid style={gridStyle} hoverable={false}>
                <div className="col-lg-12 col-md-12">
                  <AndtDPasswordBoxWrapper
                    decorator="npassword"
                    id="NPassword"
                    required="true"
                    label="New Password"
                    message="Enter New Password"
                    placeholder="Enter New Password"
                    validators={[{ validator: strongPasswordValidator }]}
                    formRef={this.formRef}
                  />
                </div>

                <div className="col-lg-12 col-md-12">
                  <AndtDPasswordBoxWrapper
                    decorator="cpassword"
                    id="CPassword"
                    required="true"
                    label="Confirm Password"
                    message="Enter Confirm Password"
                    placeholder="Enter Confirm Password"
                    validators=""
                    formRef={this.formRef}
                  />
                </div>

                <div className="col-lg-12 col-md-12 text-center">
                  <Button
                    type="primary"
                    onClick={() => this.NextPrevSteps(this.state.currentStep)}
                  >
                    Next
                  </Button>
                </div>
              </Card.Grid>
            </div>

            {currentStep === 2 && (
              <Card.Grid style={gridStyle} hoverable={false}>
                <div className="col-lg-12 col-md-12 text-right">
                  <Timer formRef={this.formRef} />
                </div>

                <div className="col-lg-12 col-md-12 text-center">
                  <Button htmlType="submit" type="primary">
                    Submit
                  </Button>
                </div>
              </Card.Grid>
            )}
          </Card>
        </Form>
        <br />
        <br />
        <br />
      </>
    );
  }
}

export default withRouter(ResetUsername);
